import { useEffect, useState } from 'react'

import { subcategoryAccessor, USER_DATA_UPDATED_EVENT } from '@mc/user-data'
import { INTEREST_EVENT_NAMES } from '../constants'

export const useSubcategoryInterests = () => {
  const [interests, setInterests] = useState<number[]>([])

  const updateInterests = () => {
    const ids =
      subcategoryAccessor.getInterestIdsByEventNames(INTEREST_EVENT_NAMES)
    setInterests(ids)
  }

  useEffect(() => {
    updateInterests()

    window?.addEventListener(USER_DATA_UPDATED_EVENT, updateInterests)
    return () => {
      window?.removeEventListener(USER_DATA_UPDATED_EVENT, updateInterests)
    }
  }, [])

  return interests
}
